import React from 'react';
import {
  AnalyticsAspDrawer,
  AnalyticsFilterDrawer,
  AnalyticsInsightDropdown,
  AnalyticsTerritoryDrawer,
} from './components';

const AnalyticsLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="flex flex-col h-full ">
      {/* Header */}
      <div className="self-stretch px-6 py-4 bg-white border-b border-neutral-200 inline-flex justify-start items-center gap-4">
        <AnalyticsInsightDropdown />
      </div>

      {/* Content */}
      <div className="flex-1 flex bg-white overflow-hidden relative">
        {/* Left drawer area */}
        <div className="absolute left-0 top-0 bottom-0 z-40">
          <AnalyticsTerritoryDrawer />
          <AnalyticsAspDrawer />
        </div>
        {/* Main content area */}
        <div className="p-6 bg-neutral-50 w-full transition-all duration-300 ease-in-out min-w-0 flex flex-col">
          {children}
        </div>

        {/* Right drawer area */}
        {/* <AnalyticsDrawer /> */}
        <AnalyticsFilterDrawer />
      </div>
    </div>
  );
};

export default AnalyticsLayout;
